
import React, { useState } from 'react';
import Header from './components/Header';
import ContentSection from './components/ContentSection';
import TopicCard from './components/TopicCard';
import { TOPICS } from './constants/content';

const App: React.FC = () => {
  const [activeTopicId, setActiveTopicId] = useState<string>(TOPICS[0].id);

  const activeTopic = TOPICS.find((topic) => topic.id === activeTopicId);

  return (
    <div className="min-h-screen bg-sky-50 text-slate-800">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <section id="topics" className="mb-12">
          <h2 className="text-3xl font-bold text-center text-sky-700 mb-8">বিষয়সূচী (Topics)</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {TOPICS.map((topic) => (
              <TopicCard
                key={topic.id}
                id={topic.id}
                title={topic.title}
                isActive={topic.id === activeTopicId}
                onClick={() => setActiveTopicId(topic.id)}
              />
            ))}
          </div>
        </section>

        <div className="space-y-12">
          {activeTopic && (
            <ContentSection key={activeTopic.id} id={activeTopic.id} title={activeTopic.title}>
              {activeTopic.content}
            </ContentSection>
          )}
        </div>
      </main>
      <footer className="text-center py-6 bg-sky-900 text-white mt-12">
        <p>&copy; 2025 | Shihab | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default App;
